import { render, staticRenderFns } from "./CgList.vue?vue&type=template&id=2faa7113&scoped=true"
import script from "./CgList.vue?vue&type=script&lang=js"
export * from "./CgList.vue?vue&type=script&lang=js"
import style0 from "./CgList.vue?vue&type=style&index=0&id=2faa7113&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faa7113",
  null
  
)

export default component.exports